import { collection, doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';

// Collection names
export const COLLECTIONS = {
  USERS: 'users',
  ORDERS: 'orders',
  PACKAGES: 'packages'
} as const;

// Initialize database schema
export const initializeDatabase = async () => {
  // Create default packages
  const packages = [
    {
      id: 'holiday-cheer',
      name: 'Holiday Cheer Package',
      price: 15,
      videoCount: 1,
      features: [
        '30-second personalized video',
        'Choice of Santa styles',
        'HD quality download',
        '48-hour delivery'
      ]
    },
    {
      id: 'family',
      name: 'Family Package',
      price: 49,
      videoCount: 6,
      features: [
        '30-second personalized videos',
        'All Santa styles included',
        'HD quality downloads',
        'Priority 24-hour delivery'
      ]
    },
    {
      id: 'santas-sleigh',
      name: "Santa's Sleigh Package",
      price: 150,
      videoCount: 15,
      features: [
        '30-second personalized videos',
        'All Santa styles included',
        'HD quality downloads',
        'Express 12-hour delivery',
        'Priority support',
        'Custom background options'
      ]
    }
  ];

  // Add packages to Firestore
  const packagesCollection = collection(db, COLLECTIONS.PACKAGES);
  for (const pkg of packages) {
    const docRef = doc(packagesCollection, pkg.id);
    const existingDoc = await getDoc(docRef);
    if (!existingDoc.exists()) {
      await setDoc(docRef, pkg);
    }
  }
};